import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import headponeshelp from "../../assets/images/headphoneshelp.png";
import customerservices from "../../assets/images/customer_services.png";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import WhyTrust from "../../layout/WhyTrust";
import medicalinsurance from "../../assets/images/medical-insurance.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import careplanimg from "../../assets/images/careplanimg.png";

export default function CarePlan() {
  const [selectedDay, setSelectedDay] = useState("7");
  const [selectedHour, setSelectedHour] = useState("12 Hours");
  const [isPhysiotherapy, setIsPhysiotherapy] = useState(false);
  const [dynamicAttributes, setDynamicAttributes] = useState([]);
  const [calculatedPrice, setCalculatedPrice] = useState("");
  const [selectedItemName, setSelectedItemName] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const normalizeHour = (str) => {
    if (!str) return "12 Hours";
    const numMatch = String(str).match(/\d+/);
    if (!numMatch) return "12 Hours";
    const val = parseInt(numMatch[0]);
    if (val === 6) return "6 Hours";
    if (val === 8) return "8 Hours";
    if (val === 12) return "12 Hours";
    if (val === 24) return "24 Hours";
    return `${val} Hours`;
  };

  useEffect(() => {
    let category = localStorage.getItem("selectedServiceCategory");

    const savedShift = localStorage.getItem("selectedShift");
    if (savedShift) {
      setSelectedHour(normalizeHour(savedShift));
    }

    const savedCart =
      localStorage.getItem("selectedLongTerm") ||
      localStorage.getItem("selectedServicesCart") ||
      localStorage.getItem("selectedShortTerm");

    if (savedCart) {
      try {
        const parsed = JSON.parse(savedCart);
        const item = Array.isArray(parsed) ? parsed[0] : parsed;
        if (item) {
          setSelectedItem(item);
          if (item.name) {
            setSelectedItemName(item.name);
          }
          if (
            item.serviceId === 2 ||
            item.serviceCategory === "physiotherapy" ||
            item.type === "physiotherapy"
          ) {
            setIsPhysiotherapy(true);
          }
          if (Array.isArray(item.attributes) && item.attributes.length > 0) {
            setDynamicAttributes(item.attributes);
          }
          if (item.selectedShift) {
            setSelectedHour(normalizeHour(item.selectedShift));
          }
          if (item.price) {
            const cleanPrice = String(item.price).replace(/[^\d.]/g, "");
            setCalculatedPrice(cleanPrice);
          }
          const text = item.selectedDays || item.duration || "";
          const match = String(text).match(/\d+/);
          if (match) {
            setSelectedDay(String(match[0]));
          }
        }
      } catch (e) {
        console.error(e);
      }
    }

    if (category === "physiotherapy") {
      setIsPhysiotherapy(true);
    }
  }, []);

  const getSubtitle = (daysNum) => {
    const d = parseInt(daysNum);
    if (d === 1) return "Immediate Care Needs";
    if (d === 7) return "Weekly Care Plan";
    if (d === 15) return "Better Value Care";
    if (d === 30) return "Complete Monthly Support";
    return `${d} Days Plan`;
  };

  const defaultDays = [
    { days: "1", title: "1 Day", subtitle: "Immediate Care Needs" },
    { days: "7", title: "7 Day", subtitle: "Weekly Care Plan" },
    { days: "15", title: "15 Day", subtitle: "Better Value Care" },
    { days: "30", title: "30 Day", subtitle: "Complete Monthly Support" },
  ];

  const formatDisplayPrice = (val) => {
    if (!val) return "";
    const num = parseFloat(String(val).replace(/[^\d.]/g, ""));
    if (isNaN(num) || num === 0) return "";
    return `₹${num.toLocaleString("en-IN")}`;
  };

  const daysToRender =
    dynamicAttributes.length > 0
      ? dynamicAttributes.map((attr) => {
          const dNum = parseInt(
            String(attr.attribute_name).match(/\d+/)?.[0] || 7,
          );
          return {
            days: String(dNum),
            title: attr.attribute_name,
            subtitle: getSubtitle(dNum),
            price: attr.price,
            rawAttr: attr,
          };
        })
      : defaultDays;

  // Auto select duration day attribute if not already matched
  useEffect(() => {
    if (daysToRender && daysToRender.length > 0) {
      const savedDuration = localStorage.getItem("selectedDuration");
      let initialDayStr = "";
      if (savedDuration) {
        const match = savedDuration.match(/\d+/);
        if (match) initialDayStr = String(match[0]);
      }
      if (!initialDayStr && selectedItem) {
        const text = selectedItem.selectedDays || selectedItem.duration || "";
        const match = String(text).match(/\d+/);
        if (match) initialDayStr = String(match[0]);
      }

      const matchedOption = daysToRender.find(
        (d) => String(d.days) === String(initialDayStr),
      );

      const targetOption = matchedOption || daysToRender[0];
      if (targetOption) {
        handleSelectDay(targetOption.days, targetOption.price);
      }
    }
  }, [dynamicAttributes]);

  const handleSelectDay = (daysNumStr, attrPrice) => {
    setSelectedDay(String(daysNumStr));
    try {
      localStorage.setItem("selectedDuration", `${daysNumStr} Days`);

      let priceToSet = attrPrice;

      // Search all cart storage keys to update day and price dynamically
      const keys = [
        "selectedLongTerm",
        "selectedServicesCart",
        "selectedShortTerm",
      ];
      keys.forEach((key) => {
        const saved = localStorage.getItem(key);
        if (saved) {
          try {
            const parsed = JSON.parse(saved);
            const isArr = Array.isArray(parsed);
            const item = isArr ? parsed[0] : parsed;
            if (item) {
              item.selectedDays = parseInt(daysNumStr);

              // Find matching attribute price if not passed directly
              if (
                !priceToSet &&
                Array.isArray(item.attributes) &&
                item.attributes.length > 0
              ) {
                const matchedAttr = item.attributes.find((a) => {
                  const n = parseInt(
                    String(a.attribute_name).match(/\d+/)?.[0],
                  );
                  return n === parseInt(daysNumStr);
                });
                if (matchedAttr && matchedAttr.price) {
                  priceToSet = matchedAttr.price;
                }
              }

              // Fallback proportional pricing calculation if no direct price exists
              if (!priceToSet && item.price) {
                const numPrice =
                  parseFloat(
                    String(item.price)
                      .replace(/,/g, "")
                      .replace(/[^\d.]/g, ""),
                  ) || 0;
                const oldDays = item.selectedDays || 7;
                if (numPrice > 0 && oldDays > 0) {
                  priceToSet = Math.round(
                    (numPrice / oldDays) * parseInt(daysNumStr),
                  );
                }
              }

              if (priceToSet) {
                const cleanPrice = String(priceToSet)
                  .replace(/,/g, "")
                  .replace(/[^\d.]/g, "");
                item.price = `₹${cleanPrice}`;
                item.selectedPrice = cleanPrice;
                setCalculatedPrice(cleanPrice);
                localStorage.setItem("selectedPrice", cleanPrice);
              }

              const shiftStr = item.selectedShift || selectedHour || "12 Hours";
              item.duration = `${daysNumStr} Days (${shiftStr})`;
              const updated = isArr ? [item] : item;
              localStorage.setItem(key, JSON.stringify(updated));
            }
          } catch (e) {
            console.error(e);
          }
        }
      });

      if (priceToSet) {
        const cleanPrice = String(priceToSet)
          .replace(/,/g, "")
          .replace(/[^\d.]/g, "");
        setCalculatedPrice(cleanPrice);
      }

      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelectHour = (hourStr) => {
    setSelectedHour(hourStr);
    try {
      localStorage.setItem("selectedShift", hourStr);
      const keys = [
        "selectedLongTerm",
        "selectedServicesCart",
        "selectedShortTerm",
      ];
      keys.forEach((key) => {
        const saved = localStorage.getItem(key);
        if (saved) {
          try {
            const parsed = JSON.parse(saved);
            const isArr = Array.isArray(parsed);
            const item = isArr ? parsed[0] : parsed;
            if (item) {
              item.selectedShift = hourStr;
              item.duration = `${item.selectedDays || selectedDay || 7} Days (${hourStr})`;
              const updated = isArr ? [item] : item;
              localStorage.setItem(key, JSON.stringify(updated));
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Header />

      <div className="labbanner_sec drblal_banner careplan-bg">
        <div className="container-fluid">
          {/* <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <span className="name_p">Care Plan</span>
          </div> */}
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="banner_content_careplan">
                <img src={medicalinsurance} alt="" className="img-fluid" />
                <div>
                  <h1>Let's create the perfect careplan for you</h1>
                  <p>Choose your preferred duration, hours and shift</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="lab_banner_img">
                {/* <img src={careplanimg} alt="" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="careplan_content_container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 col-md-6 col-12">
              <div className="left_section_careplan">
                <div className="plan-heading">
                  <h2 className="care_se_heading">
                    <span className="count">1</span> Select Duration / Days
                  </h2>
                  <p>How long do you need care for?</p>
                </div>

                <div className="select_day_careplan">
                  <div className="row g-3">
                    {daysToRender.map((dayItem, idx) => {
                      const isChecked =
                        String(selectedDay) === String(dayItem.days);
                      return (
                        <div className="col-4" key={idx}>
                          <div className="care_plan_box">
                            <input
                              type="radio"
                              name="careplan"
                              id={`day_${dayItem.days}_${idx}`}
                              checked={isChecked}
                              onChange={() =>
                                handleSelectDay(dayItem.days, dayItem.price)
                              }
                            />
                            <label
                              htmlFor={`day_${dayItem.days}_${idx}`}
                              onClick={() =>
                                handleSelectDay(dayItem.days, dayItem.price)
                              }
                            >
                              <span className="radio_circle"></span>
                              <div className="icon_box">
                                <WatchLaterOutlinedIcon />
                              </div>
                              <h4>{dayItem.title}</h4>
                              <p>{dayItem.subtitle}</p>
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="left_section_careplan">
                    {!isPhysiotherapy && (
                      <>
                        <div className="plan-heading">
                          <h2 className="care_se_heading">
                            <span className="count">2</span> Select Hours
                          </h2>
                          <p>How long do you need care for?</p>
                        </div>

                        <div className="select_time_cp">
                          <div className="row g-3">
                            <div className="col-md-12 col-6">
                              <input
                                type="radio"
                                name="select_hour_cp"
                                id="hour_6"
                                checked={selectedHour === "6 Hours"}
                                onChange={() => handleSelectHour("6 Hours")}
                              />
                              <label
                                htmlFor="hour_6"
                                className="shift_box"
                                onClick={() => handleSelectHour("6 Hours")}
                              >
                                <div>
                                  <h4>6 Hours</h4>
                                  <p>Half Day</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-12 col-6">
                              <input
                                type="radio"
                                name="select_hour_cp"
                                id="hour_8"
                                checked={selectedHour === "8 Hours"}
                                onChange={() => handleSelectHour("8 Hours")}
                              />
                              <label
                                htmlFor="hour_8"
                                className="shift_box"
                                onClick={() => handleSelectHour("8 Hours")}
                              >
                                <div>
                                  <h4>8 Hours</h4>
                                  <p>Standard</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-12 col-6">
                              <input
                                type="radio"
                                name="select_hour_cp"
                                id="hour_12"
                                checked={selectedHour === "12 Hours"}
                                onChange={() => handleSelectHour("12 Hours")}
                              />
                              <label
                                htmlFor="hour_12"
                                className="shift_box"
                                onClick={() => handleSelectHour("12 Hours")}
                              >
                                <div>
                                  <h4>12 Hours</h4>
                                  <p>Extended</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-12 col-6">
                              <input
                                type="radio"
                                name="select_hour_cp"
                                id="hour_24"
                                checked={selectedHour === "24 Hours"}
                                onChange={() => handleSelectHour("24 Hours")}
                              />
                              <label
                                htmlFor="hour_24"
                                className="shift_box"
                                onClick={() => handleSelectHour("24 Hours")}
                              >
                                <div>
                                  <h4>24 Hours</h4>
                                  <p>Live In</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="left_section_careplan">
                    {!isPhysiotherapy && (
                      <>
                        <div className="plan-heading">
                          <h2 className="care_se_heading">
                            <span className="count">3</span> Select Time / Shift
                          </h2>
                          <p>How long do you need care for?</p>
                        </div>

                        <div className="select_time_cp">
                          <div className="row g-3">
                            <div className="col-md-6 col-6">
                              <input
                                type="radio"
                                name="shift"
                                id="halfday"
                                defaultChecked
                              />
                              <label htmlFor="halfday" className="shift_box">
                                <div>
                                  <h4>8 AM - 2 PM</h4>
                                  <p>Half Day</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-6 col-6">
                              <input type="radio" name="shift" id="evening" />
                              <label htmlFor="evening" className="shift_box">
                                <div>
                                  <h4>2 PM - 8 PM</h4>
                                  <p>Evening • 6 hrs</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-6 col-6">
                              <input type="radio" name="shift" id="day8" />
                              <label htmlFor="day8" className="shift_box">
                                <div>
                                  <h4>8 AM - 4 PM</h4>
                                  <p>Day • 8 hrs</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-6 col-6">
                              <input type="radio" name="shift" id="afternoon" />
                              <label htmlFor="afternoon" className="shift_box">
                                <div>
                                  <h4>2 PM - 10 PM</h4>
                                  <p>Afternoon • 8 hrs</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-6 col-6">
                              <input type="radio" name="shift" id="dayshift" />
                              <label htmlFor="dayshift" className="shift_box">
                                <div>
                                  <h4>Day Shift</h4>
                                  <p>12 hrs</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-md-6 col-6">
                              <input
                                type="radio"
                                name="shift"
                                id="nightshift"
                              />
                              <label htmlFor="nightshift" className="shift_box">
                                <div>
                                  <h4>Night Shift</h4>
                                  <p>12 hrs</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>

                            <div className="col-12">
                              <input type="radio" name="shift" id="livein" />
                              <label
                                htmlFor="livein"
                                className="shift_box livein_box"
                              >
                                <div>
                                  <h4>Live In</h4>
                                  <p>24 hrs • Full day & night</p>
                                </div>
                                <span className="radio_btn"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div class="care-plan-card">
                <div class="care-plan-header">
                  <div>
                    <h2>Your Care Plan Summary</h2>
                    <p>Here's what you've selected</p>
                  </div>

                  <div class="header-icon">
                    <span>★</span>
                  </div>
                </div>

                <div class="plan-details">
                  <div class="plan-item">
                    <div class="plan-icon">
                      <CalendarMonthOutlinedIcon />
                    </div>

                    <div class="plan-content">
                      <span class="label">Duration</span>
                      <strong>7 Days</strong>
                      <small>Weekly Care Plan</small>
                    </div>
                  </div>

                  <div class="plan-item">
                    <div class="plan-icon">
                      <WatchLaterOutlinedIcon />
                    </div>

                    <div class="plan-content">
                      <span class="label">Hours</span>
                      <strong>6 Hours</strong>
                      <small>Half Day</small>
                    </div>
                  </div>

                  <div class="plan-item">
                    <div class="plan-icon">
                      <WbSunnyOutlinedIcon />
                    </div>

                    <div class="plan-content">
                      <span class="label">Time / Shift</span>
                      <strong>8 AM – 2 PM</strong>
                      <small>Half Day</small>
                    </div>
                  </div>
                </div>

                <div className="submit_btn_cp">
                  <button type="submit" className="submit_btn_full">
                    <Link
                      to="/nursingassesment"
                      style={{ color: "#fff", textDecoration: "none" }}
                    >
                      GO TO ASSESSMENT
                    </Link>
                  </button>
                </div>
              </div>

              <div class="help-box">
                <h4>Need help Choosing?</h4>

                <p>Our care experts are here for you.</p>

                <button class="chat-btn">
                  <a
                    href="https://wa.me/919660222061"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <WhatsAppIcon />
                    Chat with us
                  </a>
                </button>
              </div>

              {/* <div className="right_section_careplan">
                {!isPhysiotherapy && (
                  <>
                    <h2 className="care_se_heading">
                      <CalendarTodayOutlinedIcon /> Select Hours
                    </h2>
                    <div className="select_time_cp">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <input
                            type="radio"
                            name="select_hour_cp"
                            id="hour_6"
                            checked={selectedHour === "6 Hours"}
                            onChange={() => handleSelectHour("6 Hours")}
                          />
                          <label
                            htmlFor="hour_6"
                            className="shift_box"
                            onClick={() => handleSelectHour("6 Hours")}
                          >
                            <div>
                              <h4>6 Hours</h4>
                              <p>Half Day</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input
                            type="radio"
                            name="select_hour_cp"
                            id="hour_8"
                            checked={selectedHour === "8 Hours"}
                            onChange={() => handleSelectHour("8 Hours")}
                          />
                          <label
                            htmlFor="hour_8"
                            className="shift_box"
                            onClick={() => handleSelectHour("8 Hours")}
                          >
                            <div>
                              <h4>8 Hours</h4>
                              <p>Standard</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input
                            type="radio"
                            name="select_hour_cp"
                            id="hour_12"
                            checked={selectedHour === "12 Hours"}
                            onChange={() => handleSelectHour("12 Hours")}
                          />
                          <label
                            htmlFor="hour_12"
                            className="shift_box"
                            onClick={() => handleSelectHour("12 Hours")}
                          >
                            <div>
                              <h4>12 Hours</h4>
                              <p>Extended</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input
                            type="radio"
                            name="select_hour_cp"
                            id="hour_24"
                            checked={selectedHour === "24 Hours"}
                            onChange={() => handleSelectHour("24 Hours")}
                          />
                          <label
                            htmlFor="hour_24"
                            className="shift_box"
                            onClick={() => handleSelectHour("24 Hours")}
                          >
                            <div>
                              <h4>24 Hours</h4>
                              <p>Live In</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <h2 className="care_se_heading care_se_heading_2">
                      <CalendarMonthOutlinedIcon /> Select Time / Shift
                    </h2>
                    <div className="select_time_cp">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <input
                            type="radio"
                            name="shift"
                            id="halfday"
                            defaultChecked
                          />
                          <label htmlFor="halfday" className="shift_box">
                            <div>
                              <h4>8 AM - 2 PM</h4>
                              <p>Half Day</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input type="radio" name="shift" id="evening" />
                          <label htmlFor="evening" className="shift_box">
                            <div>
                              <h4>2 PM - 8 PM</h4>
                              <p>Evening • 6 hrs</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input type="radio" name="shift" id="day8" />
                          <label htmlFor="day8" className="shift_box">
                            <div>
                              <h4>8 AM - 4 PM</h4>
                              <p>Day • 8 hrs</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input type="radio" name="shift" id="afternoon" />
                          <label htmlFor="afternoon" className="shift_box">
                            <div>
                              <h4>2 PM - 10 PM</h4>
                              <p>Afternoon • 8 hrs</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input type="radio" name="shift" id="dayshift" />
                          <label htmlFor="dayshift" className="shift_box">
                            <div>
                              <h4>Day Shift</h4>
                              <p>12 hrs</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-md-6">
                          <input type="radio" name="shift" id="nightshift" />
                          <label htmlFor="nightshift" className="shift_box">
                            <div>
                              <h4>Night Shift</h4>
                              <p>12 hrs</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>

                        <div className="col-12">
                          <input type="radio" name="shift" id="livein" />
                          <label
                            htmlFor="livein"
                            className="shift_box livein_box"
                          >
                            <div>
                              <h4>Live In</h4>
                              <p>24 hrs • Full day & night</p>
                            </div>
                            <span className="radio_btn"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <h2 className="care_se_heading care_se_heading_2">
                  <CalendarMonthOutlinedIcon /> Select Start Date
                </h2>
                <div className="select_date_cp">
                  <input type="date" className="date_input_cp" />
                </div>

                <div className="submit_btn_cp">
                  <button type="submit" className="submit_btn_full">
                    <Link
                      to="/nursingassesment"
                      style={{ color: "#fff", textDecoration: "none" }}
                    >
                      GO TO ASSESSMENT
                    </Link>
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
